import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <>
      {/* ================= ABOUT SECTION ================= */}
      <section className="footer-about">
        <div className="container">
          <h4 className="footer-title">
            About <br /> MAA SHARDE DIGITAL SEVA KENDRA
          </h4>

          <p className="footer-desc">
            <strong>माँ शारदे डिजिटल सेवा केंद्र</strong> एक भरोसेमंद और
            बहुउपयोगी सेवा केंद्र है, जिसकी शुरुआत वर्ष <strong>2020</strong> में
            हुई थी। इसका उद्देश्य ग्रामीण और अर्ध-शहरी क्षेत्रों के लोगों को
            डिजिटल और बैंकिंग सेवाएँ सरल और सुलभ रूप से उपलब्ध कराना है।
            <br /><br />

            यह केंद्र एक <strong>साइबर कैफ़े</strong> के रूप में कार्य करता है,
            जहाँ ऑनलाइन फॉर्म, डॉक्यूमेंट स्कैन, फोटो प्रिंट, रिज़्यूमे,
            सरकारी परीक्षाओं के आवेदन, एडमिट कार्ड, रिज़ल्ट और स्कॉलरशिप से
            संबंधित सेवाएँ उपलब्ध हैं।
            <br /><br />

            यह केंद्र <strong>बैंकिंग कॉरेस्पॉन्डेंट (BC)</strong> के रूप में
            नकद जमा, नकद निकासी, बैलेंस चेक, पैसा ट्रांसफर और
            <strong> AEPS</strong> जैसी सेवाएँ प्रदान करता है, जिससे लोगों को
            बैंक जाने की आवश्यकता नहीं पड़ती।
            <br /><br />

            <strong>माँ शारदे डिजिटल सेवा केंद्र</strong> ईमानदारी,
            विश्वसनीयता और समयबद्ध सेवा के लिए जाना जाता है और
            <strong> Digital India</strong> को मजबूती प्रदान करता है।
          </p>
        </div>
      </section>

      {/* ================= LINKS SECTION ================= */}
      <footer className="footer-main">
        <div className="container">
          <div className="row gy-4">

            <div className="col-12 col-md-3">
              <h5>Quick Links</h5>
              <ul>
                <li><Link>Maa Sharde DSK @ Telegram</Link></li>
                <li><Link>Maa Sharde DSK @ WhatsApp</Link></li>
                <li><Link>Maa Sharde DSK @ Instagram</Link></li>
                <li><Link>Maa Sharde DSK @ Facebook</Link></li>
                <li><Link>Maa Sharde DSK @ YouTube</Link></li>
              </ul>
            </div>

            <div className="col-6 col-md-3">
              <h5>App</h5>
              <ul>
                <li><Link>Android App</Link></li>
                <li><Link>Official Website</Link></li>
              </ul>
            </div>

            <div className="col-6 col-md-3">
              <h5>Exams</h5>
              <ul>
                <li><Link>BPSC</Link></li>
                <li><Link>UPSC</Link></li>
                <li><Link>SSC</Link></li>
                <li><Link>Railway</Link></li>
                <li><Link>Police</Link></li>
              </ul>
            </div>

            <div className="col-12 col-md-3">
              <h5>More</h5>
              <ul>
                <li><Link>Navy</Link></li>
                <li><Link>Air Force</Link></li>
                <li><Link>TET</Link></li>
                <li><Link>IBPS</Link></li>
                <li><Link>Coast Guard</Link></li>
              </ul>
            </div>

          </div>
        </div>
      </footer>

      {/* ================= COPYRIGHT ================= */}
      <div className="footer-bottom">
        © {new Date().getFullYear()} All Rights Reserved |
        Designed & Managed by <strong> Nirvi Infotech</strong>
      </div>
    </>
  );
}
